// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"sr_a bhm_b bhm_bj","HomeBaseBanner__hint":"sr_b bhm_vh","HomeBaseBanner__link":"sr_c"};